module.exports = __webpack_public_path__ + "static/media/down.1dd5ad53.png";